export enum HrVentureDistributionModalMode {
  VIEW = "view",
  EDIT = "edit",
}
